import {
  Button,
  Checkbox,
  Chip,
  Input,
  Stack,
  Typography,
} from "@mui/material";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SEO from /*'../../common/SEO'*/ "../../../src/common/SEO";
import Layout from "../../../src/common/Layout";

const MajorPursuePage = () => {
  const [clicked, setClicked] = useState(false);
  const [text, setText] = useState(null);
  const [selected, setSelected] = useState(false);

  // const [, setgrade12] = useState(false);

  const navigate = useNavigate();

  const handleClick = (e) => {
    if (clicked == false) {
      setSelected(true);
      setClicked(true);
    } else {
      setClicked(false);
      setSelected(false);
    }

    setText(e.target.innerHTML);
    console.log(e.target.innerHTML);
    console.info("You clicked the Chip.");
  };

  const handleClickButton = () => {
    navigate("/englishtest");
  };

  return (
    <>
      <SEO title="CourseSelection" />
      <Layout>
        <div className="edu-course-area edu-section-gap bg-color-white rishabhCSSBackground">
          <div className="container">
            <div className=" grid h-screen place-items-center">
              <div className="flex flex-col h-screen place-items-center justify-center countryPicker">
                <div>
                  <Typography color="secondary"
                    fontSize={28}
                    align="center"
                    className="mb-20 text-16 font-bold text-[#603aa2] textAboveCountry equalMargin">
                    What is your highest education level?
                  </Typography>
                </div>
                {/* <div className="p-20 grid grid-cols-3 gap-6"> */}
                <div className="p-20  flex">
                  <Stack direction="row" spacing={1}className="crad equalMargin">
                    <Chip
                      // children={<Checkbox />}
                      sx={{fontSize:"15px", color:"white"}}
                      size="medium"
                      label="Management"
                      className="p-20 rounded-full font-bold border-3 text-14"
                      // variant="outlined"
                      style={{
                        backgroundColor: selected ? "#603aa2" : "#c59bdb",
                      }}
                      onClick={(e) => handleClick(e)}
                      variant="outlined"
                    />
                    <Chip
                      label="Engineering"
                      sx={{fontSize:"15px", color:"white"}} 
                      size="medium"
                      //  variant="outlined"
                      className="p-20 rounded-full font-bold border-3 text-14"
                      style={{ backgroundColor: "#c59bdb" }}
                      variant="outlined"
                      //  variant={selected ? "filled" : "outlined"}
                      // color="info"
                      onClick={handleClick}
                    />
                    <Chip
                      label="Design"
                      sx={{fontSize:"15px", color:"white"}}
                      size="medium"
                      variant="outlined"
                      style={{ backgroundColor: "#c59bdb" }}
                      className="p-20 rounded-full font-bold border-3 text-14"
                      //  variant={selected ? "filled" : "outlined"}
                      // color="info"
                      onClick={handleClick}
                    />
                    <Chip
                      label="Law"
                      sx={{fontSize:"15px", color:"white"}}
                      size="large"
                      variant="outlined"
                      style={{ backgroundColor: "#c59bdb" }}
                      className="p-20 rounded-full font-bold border-3 text-14"
                      //  variant={selected ? "filled" : "outlined"}
                      // color="info"
                      onClick={handleClick}
                    />
                  </Stack>
                </div>
                {/* </div> */}

                {/* <div>
                <Typography className='p-20 text-blue font-bold text-20 flex justify-center'>
                What is your expected or gained percentage in {text} ?
                </Typography>
            </div>
            <div className='flex justify-center'>
                <Input type='number'></Input>
            </div> */}
                <div className="d-flex mt-5 items-center  justify-center crad equalMargin">
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={handleClickButton}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default MajorPursuePage;
